import { findLast, upperFirst } from 'lodash';
import { Dispatch, SetStateAction, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import shallow from 'zustand/shallow';

import { IMissingDocumentInformation } from '../../../pages/PersonalInformation/PersonalInformation.types';
import { DOCUMENTS_SIDES } from '../../../shared/constants';
import { IUserDocument } from '../../../shared/ts/document';
import useStore from '../../../store';
import DocumentField from '../../DocumentField';
import {
  StyledContainer,
  StyledMainTitle,
  StyledTitle,
  StyledWrapper,
} from './UserDocuments.styles';
import { filterMissingUserDocuments } from './utils/filterMissingUserDocument';

const UserDocuments = ({
  setMissingUserDocument,
}: {
  setMissingUserDocument?: Dispatch<
    SetStateAction<IMissingDocumentInformation | null>
  >;
}): JSX.Element | null => {
  const { t } = useTranslation(['common', 'translation', 'form']);

  const { user, userDocuments } = useStore(
    state => ({
      user: state.user,
      userDocuments: state.userDocuments,
    }),
    shallow,
  );

  const idDocument = findLast(userDocuments, {
    type: 'identity_document',
  }) as IUserDocument;

  const taxNumberDocument = findLast(userDocuments, {
    type: 'tax_number',
  }) as IUserDocument;

  useEffect(() => {
    if (setMissingUserDocument) {
      const missingDocument = filterMissingUserDocuments(userDocuments);
      setMissingUserDocument(missingDocument);
    }
  }, [userDocuments]);
  return (
    user && (
      <StyledWrapper>
        <StyledMainTitle>
          {upperFirst(t('translation:documents'))}
        </StyledMainTitle>
        <StyledTitle>
          {upperFirst(
            user.type === 'tenant'
              ? t('idCardOrPassport')
              : t('form:identityDocumentLL'),
          )}
        </StyledTitle>
        <StyledContainer>
          <DocumentField
            title={upperFirst(t('front'))}
            type="identity_document"
            documentUploaded={idDocument}
            documentSide={DOCUMENTS_SIDES.FRONT}
            ownerId={user.id}
          />
          <DocumentField
            title={upperFirst(t('rear'))}
            type="identity_document"
            documentUploaded={idDocument}
            documentSide={DOCUMENTS_SIDES.REAR}
            ownerId={user.id}
          />
          <StyledTitle>{upperFirst(t('fiscalCode'))}</StyledTitle>
          <DocumentField
            title={upperFirst(t('front'))}
            type="tax_number"
            documentUploaded={taxNumberDocument}
            ownerId={user.id}
          />
        </StyledContainer>
      </StyledWrapper>
    )
  );
};

export default UserDocuments;
